import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "../home/CtaButtons";
import { ArticleCard } from "./ArticleCard";
import { relatedArticles, useArticles, useKbCategories } from "../../lib/kennisbank";

// Drie passende kennisbankartikelen; gebruikt op informatiepagina's en onder artikelen.
export const KbRelated = ({ category, onderwerp, exclude, title = "Uit de kennisbank", eyebrow = "Kennisbank", tone = "white" }) => {
  const articles = useArticles();
  const cats = useKbCategories();
  const items = relatedArticles(articles, { category, onderwerp, exclude });
  if (!items.length) return null;
  return (
    <section aria-labelledby="kb-related-title" className={`section ${tone === "slate" ? "border-t border-slate-200 bg-slate-50" : ""}`} data-testid="kb-related">
      <div className="container-tight">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading id="kb-related-title" eyebrow={eyebrow} title={title} />
          <Link to="/blog" className="inline-flex items-center gap-1.5 text-[15px] font-semibold text-maas hover:underline" data-testid="kb-related-all">Alle artikelen <ArrowRight className="h-4 w-4" aria-hidden="true" /></Link>
        </div>
        <ul className="mt-8 grid gap-5 md:grid-cols-3">
          {items.map((a) => <li key={a.slug}><ArticleCard a={a} cats={cats} testid={`kb-related-${a.slug}`} /></li>)}
        </ul>
      </div>
    </section>
  );
};
